import React, { useState } from "react";
import { FiEye, FiEyeOff, FiLock } from "react-icons/fi";
import styles from "../Login/Login.module.css";
import GreenRockLogo from "../../assets/images/green_rock.png";
import Input from "../../components/Input/Input";
import Button from "../../components/Button/Button";
import { useNavigate } from "react-router-dom";

const ResetPassword: React.FC = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleReset = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    if (!password || !confirmPassword) {
      setError("Please enter and confirm your new password.");
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      setSuccess("Password reset successful! You can now log in.");
      setPassword("");
      setConfirmPassword("");
      setTimeout(() => navigate("/login"), 1500);
    }, 1200);
  };

  return (
    <div className={styles.container}>
      <div className={styles.loginBox}>
        <div className={styles.logoContainer}>
          <img
            src={GreenRockLogo}
            alt="Green Rock Logo"
            className={styles.logo}
          />
        </div>
        <div className={styles.header}>
          <p>Reset your password</p>
        </div>
        {error && <div className={styles.error}>{error}</div>}
        {success && (
          <div
            style={{
              color: "#388e3c",
              background: "#e8f5e9",
              borderRadius: 6,
              padding: "8px 12px",
              width: "100%",
              textAlign: "center",
              fontSize: "0.98rem",
              marginBottom: 8,
            }}
          >
            {success}
          </div>
        )}
        <form onSubmit={handleReset} className={styles.form}>
          <Input
            type={showPassword ? "text" : "password"}
            placeholder="New password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            icon={<FiLock className="inputIcon" />}
            name="password"
            autoComplete="new-password"
            rightIcon={
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className={styles.showPasswordButton}
                tabIndex={-1}
                aria-label={showPassword ? "Hide password" : "Show password"}
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  margin: 0,
                }}
              >
                {showPassword ? (
                  <span>
                    <FiEye />
                  </span>
                ) : (
                  <span>
                    <FiEyeOff />
                  </span>
                )}
              </button>
            }
          />
          <Input
            type={showConfirmPassword ? "text" : "password"}
            placeholder="Confirm new password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            icon={<FiLock className="inputIcon" />}
            name="confirmPassword"
            autoComplete="new-password"
            rightIcon={
              <button
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className={styles.showPasswordButton}
                tabIndex={-1}
                aria-label={
                  showConfirmPassword ? "Hide password" : "Show password"
                }
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  margin: 0,
                }}
              >
                {showConfirmPassword ? (
                  <span>
                    <FiEye />
                  </span>
                ) : (
                  <span>
                    <FiEyeOff />
                  </span>
                )}
              </button>
            }
          />
          <Button type="submit" loading={isLoading} disabled={isLoading}>
            Reset Password
          </Button>
        </form>
        <div className={styles.terms}>
          <p>
            By continuing, you agree to Green Rock's{" "}
            <a href="/terms" className={styles.link}>
              Terms of Use
            </a>
            . Read our{" "}
            <a href="/privacy" className={styles.link}>
              Privacy Policy
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
